import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import keys from "../store/keys";
import { setKey, clearKeys } from "../store/actions";
import { connect } from "react-redux";
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import utils from '../utils/utils';
import adminService from '../services/admin';

function ResetPassword({
    session,
    setKey,
    clearKeys,
    ...props
}) {
    const { i18n } = useTranslation();
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [redirectTo, setRedirectTo] = useState(null);

    useEffect(() => {
        clearKeys();
    }, []);

    const handleSubmit = async e => {
        e.preventDefault();
        if (!email || email.length === 0) {
            setErrorMessage(i18n.t('email_required'));
            return;
        } else {
            if (!utils.isValidEmail(email)) {
                setErrorMessage(i18n.t('invalid_email'));
                return;
            }
        }

        await adminService.forgotPassword(email)
            .then(result => {
                if (result.error) {
                    setErrorMessage(result.error);
                    return;
                }

                if (result.data) {
                    setErrorMessage('');
                    setSuccessMessage(i18n.t('login_success_redirect'));
                    // Logic for redirecting or closing can go here
                }
            });
    }

    const modalStyles = {
        width: "400px",
        height: "auto",
        bottom: "auto",
        top: "50%",
        transform: "translateY(-50%)",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 15px 40px rgba(0,0,0,0.2)"
    };

    return (
        <Rodal visible={session.showResetPassword}
            onClose={() => setKey(keys.showResetPassword, false)}
            closeOnEsc={false}
            closeMaskOnClick={false}
            customStyles={modalStyles}
            showCloseButton={true}>
            <div className="reset-password-container">
                {redirectTo && <Redirect push to={redirectTo} />}
                <form onSubmit={handleSubmit}>
                    <div className="text-center mb-4">
                        <img className="img-fluid" src="/logo.png" alt="Logo" style={{ maxWidth: '120px' }} />
                    </div>

                    <h4 className="text-center mb-4 font-weight-bold" style={{ color: '#333' }}>{i18n.t('reset_your_password')}</h4>

                    <div className="form-group mb-3">
                        <label htmlFor="txtEmail" className="font-weight-bold text-muted small text-uppercase mb-2">{i18n.t('email')}</label>
                        <input type="email"
                            className="form-control form-control-lg"
                            placeholder="name@example.com"
                            required="required"
                            onBlur={e => setErrorMessage(``)}
                            id="txtEmail"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            style={{ fontSize: '16px' }} />
                    </div>

                    {errorMessage && <div className="alert alert-danger font-size-sm p-2 mb-3">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success font-size-sm p-2 mb-3">{successMessage}</div>}

                    <div className="form-group mb-3">
                        <button type="submit" className="btn btn-primary btn-block btn-lg w-100 font-weight-bold" disabled={successMessage}>
                            {i18n.t('send_reset_link')}
                        </button>
                    </div>

                    <div className="text-center mt-4">
                        <span className="text-muted mr-2">{i18n.t('want_to_login')}</span>
                        <button type="button" className="btn btn-link p-0 font-weight-bold text-decoration-none" onClick={e => {
                            setKey(keys.showResetPassword, false);
                            setKey(keys.showLogin, true)
                        }}>{i18n.t('login_here')}
                        </button>
                    </div>
                </form>
            </div>
        </Rodal>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value)),
    clearKeys: () => dispatch(clearKeys())
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);